import api from '@/api/api';
import { TMarketCreationResponse } from '../marketCreation.types';
import { TUpdatePropositionBody } from './updateProposition.types';
import { isWincore } from '@/features/betApprovals/pages/BetApprovals/tabs/Approvals';
import { getPrefixPath } from '@/common/utils';

const updatePropositionURL = `/${getPrefixPath(
  isWincore
)}/trade-manager/market-creation/update-proposition`;

// Trade Manager - Update Proposition

export const mutateUpdateProposition = (body: TUpdatePropositionBody) =>
  api
    .post<TMarketCreationResponse>(updatePropositionURL, body)
    .then((res) => res.data);
